/* Badache cart drawer
   - nav arrows (prev/next) over the recos carousel — in `.bd-cd__recos-header` (next to title)
   - visibility driven by scroll position
   - outside-click (overlay or anywhere outside the panel) closes the drawer
   Survives re-renders via event delegation + MutationObserver. */

(function () {
  // === Free-shipping progress bar (client-authoritative) ===
  // The AJAX re-render paths don't always refresh the progress area, so we recompute
  // it from live cart data whenever the drawer opens or the cart changes.
  function bdFormatEuros(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    s = s.replace(/,00$/, ''); // mimic money_without_trailing_zeros
    return s + '€';
  }

  function updateProgress(cart) {
    var wrap = document.querySelector('[data-bd-progress]');
    if (!wrap || !cart || typeof cart.total_price !== 'number') return;
    var threshold = parseInt(wrap.getAttribute('data-threshold'), 10);
    if (!threshold) return;
    var total = cart.total_price;
    var pct = Math.round((total / threshold) * 100);
    if (pct > 100) pct = 100;
    if (pct < 0) pct = 0;

    var fill = wrap.querySelector('.bd-cd__progress-fill');
    if (fill) fill.style.width = pct + '%';
    var bar = wrap.querySelector('.bd-cd__progress-bar');
    if (bar) bar.setAttribute('aria-valuenow', pct);

    var label = wrap.querySelector('.bd-cd__progress-label');
    if (!label) return;
    var remaining = threshold - total;
    if (remaining > 0) {
      label.classList.remove('bd-cd__progress-label--complete');
      label.innerHTML =
        (wrap.getAttribute('data-before') || '') +
        ' <strong>' + bdFormatEuros(remaining) + '</strong> ' +
        (wrap.getAttribute('data-after') || '');
    } else {
      label.classList.add('bd-cd__progress-label--complete');
      label.textContent = wrap.getAttribute('data-free') || '';
    }
  }

  function refreshProgress() {
    if (!document.querySelector('[data-bd-progress]')) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(updateProgress)
      .catch(function () {});
  }

  // Applique la largeur directement depuis les data-attributes rendus par Liquid
  // (fiable au 1er rendu et après chaque re-render AJAX, sans attendre de fetch).
  function applyProgressDom(wrap) {
    var threshold = parseInt(wrap.getAttribute('data-threshold'), 10);
    var total = parseInt(wrap.getAttribute('data-total'), 10);
    if (!threshold || isNaN(total)) return;
    var pct = Math.round((total / threshold) * 100);
    if (pct > 100) pct = 100;
    if (pct < 0) pct = 0;
    var fill = wrap.querySelector('.bd-cd__progress-fill');
    if (fill) fill.style.width = pct + '%';
    var bar = wrap.querySelector('.bd-cd__progress-bar');
    if (bar) bar.setAttribute('aria-valuenow', pct);
  }
  function applyAllProgress(scope) {
    (scope || document).querySelectorAll('[data-bd-progress]').forEach(applyProgressDom);
  }

  function wireProgressPubSub() {
    if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.cartData) updateProgress(e.cartData);
        else refreshProgress();
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireProgressPubSub);
  } else {
    wireProgressPubSub();
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    try { if (typeof drawer.close === 'function') drawer.close(); } catch (_) {}
  }

  function getNavs(scrollEl) {
    var recos = scrollEl.closest('.bd-cd__recos');
    if (!recos) return { prev: null, next: null };
    return {
      prev: recos.querySelector('.bd-cd__recos-nav--prev'),
      next: recos.querySelector('.bd-cd__recos-nav--next')
    };
  }

  function updateNavs(scrollEl) {
    var nav = getNavs(scrollEl);
    if (!nav.prev || !nav.next) return;
    var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
    if (maxScroll <= 1) {
      nav.prev.hidden = true;
      nav.next.hidden = true;
      return;
    }
    nav.prev.hidden = scrollEl.scrollLeft <= 1;
    nav.next.hidden = scrollEl.scrollLeft >= maxScroll - 1;
  }

  function setupNavs(wrap) {
    if (wrap.dataset.bdNavSetup === '1') return;
    wrap.dataset.bdNavSetup = '1';
    var scrollEl = wrap.querySelector('.bd-cd__recos-scroll');
    if (!scrollEl) return;
    var nav = getNavs(scrollEl);
    if (!nav.prev || !nav.next) return;

    function getStep() {
      var first = scrollEl.querySelector('.bd-cd__reco-card');
      if (first) {
        var rect = first.getBoundingClientRect();
        return rect.width + 10;
      }
      return 258;
    }

    nav.prev.addEventListener('click', function () {
      scrollEl.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    nav.next.addEventListener('click', function () {
      scrollEl.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    updateNavs(scrollEl);
  }

  // Drive nav visibility on scroll
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('bd-cd__recos-scroll')) updateNavs(t);
    },
    { capture: true, passive: true }
  );

  // === Outside-click closes the drawer ===
  // Listen on the open phase to fire before any inner handlers that might stopPropagation later.
  // Track when the drawer JUST opened so we don't immediately close it on the same click sequence.
  var justOpenedTs = 0;

  // Observe class changes on cart-drawer so we know when it activates
  var classObserver = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.attributeName !== 'class') return;
      var el = m.target;
      if (el.classList && el.classList.contains('active') && el.tagName && el.tagName.toLowerCase() === 'cart-drawer') {
        justOpenedTs = Date.now();
        refreshProgress();
      }
    });
  });

  function watchDrawer(d) {
    if (d.dataset.bdOutsideWatch === '1') return;
    d.dataset.bdOutsideWatch = '1';
    classObserver.observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  function findActiveDrawer() {
    return document.querySelector('cart-drawer.bd-cart-drawer.active');
  }

  document.addEventListener('click', function (e) {
    var drawer = findActiveDrawer();
    if (!drawer) return;

    // Skip clicks within ~300ms of opening (avoid the opening click closing it)
    if (Date.now() - justOpenedTs < 300) return;

    // Click inside the panel → don't close
    var panel = drawer.querySelector('.bd-cd__panel');
    if (panel && panel.contains(e.target)) return;

    // Click on cart trigger (would re-open after close) → don't close (let the trigger handler toggle naturally)
    if (e.target.closest && (
      e.target.closest('[data-bd-cart-trigger]') ||
      e.target.closest('a[href="/cart"]') ||
      e.target.closest('a[href$="/cart"]')
    )) return;

    closeDrawer(drawer);
  });

  function initAll() {
    document.querySelectorAll('.bd-cd__recos-wrap').forEach(setupNavs);
    document.querySelectorAll('.bd-cd__recos-scroll').forEach(updateNavs);
    document.querySelectorAll('cart-drawer.bd-cart-drawer').forEach(watchDrawer);
    applyAllProgress();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 120);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches) {
          if (node.matches('.bd-cd__recos-wrap')) setupNavs(node);
          if (node.matches('.bd-cd__recos-scroll')) updateNavs(node);
          if (node.matches('cart-drawer.bd-cart-drawer')) watchDrawer(node);
          if (node.matches('[data-bd-progress]')) applyProgressDom(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.bd-cd__recos-wrap').forEach(setupNavs);
          node.querySelectorAll('.bd-cd__recos-scroll').forEach(updateNavs);
          node.querySelectorAll('cart-drawer.bd-cart-drawer').forEach(watchDrawer);
          applyAllProgress(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

/* =============================================================
   Ajout AJAX des recommandations du tiroir
   Autonome : ne dépend pas de product-form.js (qui n'est pas
   chargé sur toutes les pages). Rafraîchit le tiroir via l'API
   Section Rendering + le compteur du header.
   ============================================================= */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var ADD_URL = ROOT.replace(/\/$/, '') + '/cart/add.js';
  var CART_URL = ROOT.replace(/\/$/, '') + '/cart.js';

  function refreshCount() {
    var el = document.querySelector('[data-bd-cart-count]');
    if (!el) return;
    fetch(CART_URL, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        el.textContent = c.item_count;
        el.classList.toggle('is-empty', c.item_count === 0);
      })
      .catch(function () {});
  }

  function swapDrawer(html) {
    if (!html) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var cur = document.querySelector('#CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    } catch (err) {}
  }

  // Phase capture : on intercepte AVANT product-form.js pour éviter tout double-ajout.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('.bd-cd__reco-card')) return;

    var idInput = form.querySelector('[name="id"]');
    var id = idInput && idInput.value;
    if (!id) return; // pas d'id → on laisse le comportement natif en secours

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('button[type="submit"]');
    if (btn && btn.hasAttribute('disabled')) return;
    if (btn) { btn.setAttribute('disabled', ''); btn.classList.add('is-loading'); }

    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: id,
        quantity: 1,
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.d;
        swapDrawer(res.d.sections && res.d.sections['cart-drawer']);
        refreshCount();
      })
      .catch(function (err) {
        if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); }
        console.warn('[badache] Ajout recommandation échoué', err);
      });
  }, true);
})()
